import axios from 'axios';
import { applyAuthRequestInterceptor, applyEnvelopeInterceptor } from './axiosInterceptors';

/** API origin (scheme+host, no path). Empty for same-origin local dev. */
const API_ORIGIN = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * Creates an authenticated axios instance.
 * Identity headers (X-User-Id, X-Organization-Id, etc.) are injected
 * by the API Gateway from the JWT session — no need to set them here.
 */
function createServiceClient(path: string) {
  const client = axios.create({
    baseURL: `${API_ORIGIN}${path}`,
    timeout: 30000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });

  applyAuthRequestInterceptor(client);
  applyEnvelopeInterceptor(client);

  return client;
}

/** Contract-service: templates, reviews, onlyoffice editor */
export const contractServiceClient = createServiceClient('/api/contract-service');

/** File-management-service: upload, download, delete */
export const fileManagementClient = createServiceClient('/api/file-management-service');

/** @deprecated — use contractServiceClient or fileManagementClient */
const documentServiceClient = contractServiceClient;
export default documentServiceClient;
